// src/utils/symptomUtils.js

/**
 * Processes symptom observations data
 * Used in: CallSessionDetails (replaces the useMemo logic)
 */
export const processSymptomData = (symptomObservations) => {
  if (!symptomObservations || !Array.isArray(symptomObservations)) return {};

  const symptomData = {};
  symptomObservations.forEach((obs) => {
    if (!obs.observation_type) return;
    if (!obs.value || obs.value.trim() === '') return;

    symptomData[obs.observation_type] = {
      value: obs.value,
      description: obs.description || 'No description available',
      unit: obs.observation_type_unit_of_measure || null,
    };
  });
  return symptomData;
};